import { Directive } from '@angular/core';

@Directive({
    selector: '[appMaxAlphanumeric]',
    standalone: false
})
export class MaxAlphanumericDirective {

  constructor() { }

}
